var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content fondocardsmenu"},[_c('div',{},[_c('div',{staticClass:""},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 text-center"},[_c('h2',[_vm._v(" Semestre Anterior")])]),_c('div',{staticClass:"col-6 text-center"},[_c('h2',[_vm._v(" Semestre Siguiente")])])])])])])
}]

export { render, staticRenderFns }